'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayablePreview = exports.CommunityContentPlayable = exports.StoreShape = exports.MiniProfileFeedUser = exports.ReactionUserDetails = exports.CommunityContentId = exports.FeedUser = exports.FeedUserId = exports.AdsShape = exports.adTagShape = undefined;

var _react = require('react');

var _communityContentType = require('./community-content-type');

var _communityContentType2 = _interopRequireDefault(_communityContentType);

var _feedUserType = require('./feed-user-type');

var _feedUserType2 = _interopRequireDefault(_feedUserType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adTagShape = exports.adTagShape = _react.PropTypes.shape({
  vastTag: _react.PropTypes.string.isRequired,
  mobileVastTag: _react.PropTypes.string.isRequired,
  preRollAdData: _react.PropTypes.object.isRequired
});

var AdsShape = exports.AdsShape = _react.PropTypes.arrayOf(_react.PropTypes.shape({
  offset: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  src: _react.PropTypes.string.isRequired,
  type: _react.PropTypes.oneOf(['vast', 'vmap'])
}));

var FeedUserId = exports.FeedUserId = _react.PropTypes.shape({
  relatedId: _react.PropTypes.string.isRequired,
  type: _react.PropTypes.oneOf(Object.keys(_feedUserType2.default).map(function (key) {
    return _feedUserType2.default[key];
  })).isRequired
});

var FeedUser = exports.FeedUser = _react.PropTypes.shape({
  feedUserId: FeedUserId.isRequired,
  followersCount: _react.PropTypes.number,
  friendsCount: _react.PropTypes.number,
  nameComponents: _react.PropTypes.shape({
    f: _react.PropTypes.string, // first name
    l: _react.PropTypes.string, // last name
    n: _react.PropTypes.string, // author name
    s: _react.PropTypes.string, // school
    t: _react.PropTypes.string // team
  }),
  profileImages: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    path: _react.PropTypes.string,
    size: _react.PropTypes.number,
    url: _react.PropTypes.string
  }))
});

var CommunityContentId = exports.CommunityContentId = _react.PropTypes.shape({
  relatedId: _react.PropTypes.string.isRequired,
  secondaryRelatedId: _react.PropTypes.string,
  type: _react.PropTypes.oneOf(Object.keys(_communityContentType2.default).map(function (key) {
    return _communityContentType2.default[key];
  })).isRequired
});

var ReactionUserDetails = exports.ReactionUserDetails = _react.PropTypes.shape({
  feedUserId: FeedUserId.isRequired,
  followersCount: _react.PropTypes.number,
  formattedPositions: _react.PropTypes.string,
  imageUrl: _react.PropTypes.string.isRequired,
  jersey: _react.PropTypes.string,
  name: _react.PropTypes.string.isRequired,
  positions: _react.PropTypes.arrayOf(_react.PropTypes.string),
  school: _react.PropTypes.string,
  schoolLocation: _react.PropTypes.string,
  schoolName: _react.PropTypes.string,
  sportId: _react.PropTypes.string,
  url: _react.PropTypes.string
});

var MiniProfileFeedUser = exports.MiniProfileFeedUser = _react.PropTypes.shape({
  feedUserId: FeedUserId,
  isAthlete: _react.PropTypes.bool,
  isAuthor: _react.PropTypes.bool,
  isTeam: _react.PropTypes.bool,
  athleteProfileUrl: _react.PropTypes.string,
  authorProfileUrl: _react.PropTypes.string,
  teamProfileUrl: _react.PropTypes.string,
  profileImageUrl: _react.PropTypes.string,
  name: _react.PropTypes.string,
  jersey: _react.PropTypes.string,
  positions: _react.PropTypes.string,
  classLevel: _react.PropTypes.string,
  school: _react.PropTypes.string,
  city: _react.PropTypes.string,
  state: _react.PropTypes.string,
  highlightViews: _react.PropTypes.number,
  followersCount: _react.PropTypes.number,
  friendsCount: _react.PropTypes.number
});

var StoreShape = exports.StoreShape = _react.PropTypes.shape({
  subscribe: _react.PropTypes.func.isRequired,
  dispatch: _react.PropTypes.func.isRequired,
  getState: _react.PropTypes.func.isRequired
});

var CommunityContentPlayable = exports.CommunityContentPlayable = _react.PropTypes.shape({
  src: _react.PropTypes.string.isRequired,
  communityContentId: CommunityContentId.isRequired
});

var PlayablePreview = exports.PlayablePreview = _react.PropTypes.shape({
  ownerName: _react.PropTypes.string.isRequired,
  thumbnail: _react.PropTypes.string.isRequired,
  title: _react.PropTypes.string.isRequired
});